import { processBrandsData } from 'helpers/global-search'
import { getGlobalSearchDisplay } from '../../selectors'
import resultBlockHoc from '../resultBlockHoc'
import Brand from '../Brand'
import SortableResultList from '../SortableResultList'

const mapStateToProps = state => ({
  displayGlobalSearch: getGlobalSearchDisplay(state)
})

export default resultBlockHoc({
  TileComponent: Brand,
  blockName: 'Brand',
  mapStateToProps,
  processData: processBrandsData,
  type: 'BOTBrandsSearchResults'
})(SortableResultList)
